import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPause = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 2.91797H4.66667V11.0846H3.5V2.91797ZM9.33333 2.91797H10.5V11.0846H9.33333V2.91797Z",
		fill: "#03314B"
	})
});
export default SvgIconPause;
